import axios from 'axios';
import * as React from 'react';
import { requestCreateApTemplate } from '../asyncHelpers/actionPlanTemplateService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { ApTemplate, CreateApTemplateRequest } from '../sic-lib/types/ApTemplate';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncCreateApTemplate
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestCreateApTemplate HTTP request
 */
export default function useAsyncCreateApTemplate() {
    const request_token = axios.CancelToken.source();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncCreateApTemplate = async (
        apTemplate: CreateApTemplateRequest,
    ): Promise<ApTemplate | undefined> => {
        try {
            setRequestStatus(RequestStatus.none);

            const { data } = await requestCreateApTemplate(apTemplate, request_token.token);

            setRequestStatus(RequestStatus.success);

            return data;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while creating Action Plan Template');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncCreateApTemplate,
    };
}
